// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__7dcus","footer":"ModalFilter_footer__2c0YE"};